export default __webpack_public_path__ + "static/media/popcorn-logo.52736815.svg";